import { Eureka_CompleteInfo_Type, Eureka_EurekaSearchToken_Type, } from '../../services/generated/graphql-types';
export const DEBOUNCE_DURATION = 200;
export const MAX_COMPLETIONS = 5;
export const COMPLETE_INFO = [
    { type: Eureka_CompleteInfo_Type.Query, requiredCompletions: MAX_COMPLETIONS },
    { type: Eureka_CompleteInfo_Type.Object, requiredCompletions: MAX_COMPLETIONS },
];
export var EurekaObjectType;
(function (EurekaObjectType) {
    EurekaObjectType["ANSWER"] = "ANSWER";
    EurekaObjectType["PINBOARD"] = "PINBOARD";
    EurekaObjectType["VISUALIZATION"] = "VISUALIZATION";
})(EurekaObjectType || (EurekaObjectType = {}));
export var EurekaQueryCompletionType;
(function (EurekaQueryCompletionType) {
    EurekaQueryCompletionType["RECENT"] = "RECENT";
    EurekaQueryCompletionType["POPULAR"] = "POPULAR";
})(EurekaQueryCompletionType || (EurekaQueryCompletionType = {}));
export const tokenizeQuery = (query) => {
    const trimmed = query.trim();
    if (!trimmed)
        return [];
    return trimmed
        .split(/\s+/)
        .map(word => ({ value: word, type: Eureka_EurekaSearchToken_Type.Unrecognized }));
};
export const mapObjectCompletions = (results) => results
    .filter((r) => r?.type === 'OBJECT' &&
    !!r?.objectResult?.guid)
    .map(r => ({
    guid: r.objectResult.guid,
    name: r.token?.value || r.objectResult.name,
    authorName: r.objectResult.authorName,
    type: r.objectResult.type,
    parentGuid: r.objectResult.parentGuid,
}));
export const mapQueryCompletions = (queryResults) => queryResults
    .filter((q) => !!q?.query)
    .map(q => ({
    query: q.query,
    type: q.type,
}));
//# sourceMappingURL=spotlight-completions.util.js.map